export class UserState {

  public noActiveSubscription: boolean;
  public subscriptionExpired: boolean;
  public hasActiveDomainAgreement: boolean;
  public paymentFailed: boolean;
  public stripeSbcrstatus: string;
  public subscriptionBillingType: string;

}
